import { render, staticRenderFns } from "./CartOverviewItem.vue?vue&type=template&id=97f277fc&"
import script from "./CartOverviewItem.vue?vue&type=script&lang=js&"
export * from "./CartOverviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97f277fc')) {
      api.createRecord('97f277fc', component.options)
    } else {
      api.reload('97f277fc', component.options)
    }
    module.hot.accept("./CartOverviewItem.vue?vue&type=template&id=97f277fc&", function () {
      api.rerender('97f277fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/CartOverviewItem.vue"
export default component.exports